
<template>
  <div class="site" style="padding-top: 20px;">
     <!-- eslint-disable  -->
      <CaseHead :stepNum="stepNum" :siteName='siteName' :regPage='regPage' :cancalChild = 'cancalChild' :thisScore='thisScore' :numScore='numScore' :isHelpShow='isHelpShow' :isChisShow='isChisShow' :helpPop="isHelp" :knowledgePop="isChis" :isShowScore='isScore' :isVideo='isVideo' :isLeasing='isLeasing' :goRegPage='goRegPage' :AccountInfo='AccountInfo'></CaseHead>
      <div class="content">
        <div class="view">
          <iframe ref="iframe" id="bdIframe" :src="view.src" frameborder="0" hight='auto'></iframe>
        </div>
      </div>
      <div class="colsPop"  v-drag v-if="AccountInfo">
        <div class="colsCont">
          <div class="close" @click="AccountInfo=false">
            <img src="../../assets/images/close.svg" >
          </div>
          <div class="tab">
            <div class="tabs" v-for="(item,index) in tabs" :key="index" :class="{avt:tabsIndex==index}" @click="tabsClick(index)">{{item.name}}</div>
          </div>
          <div class="boxConts" v-if="tabsIndex==0">
            <div class="cos">
                <ul>
                  <li> 
                    <div class="name">要求：</div>
                    <div class="dev">按照提供的信息创建一个商品Listing <span>此案例素材适用于亚马逊后台商品上传成功的参考信息，模拟练习可复制粘贴（注！！请勿在亚马逊后台填写）</span></div>
                  </li>
                  <li > 
                    <div class="name">评分：</div>
                    <div class="dev"><span>评分判断只适用于提供给您的案例素材信息，其他信息填入不做评分。</span></div>
                  </li>
                  
                  <li > 
                    <div class="name">商品分类选择：</div>
                    <div class="dev">家居与厨房Home & Kitchen > 厨房和餐厅(Kitchen & Dining) > 小家电(Small Appliances) > 面包机(Bread Machines)</div>
                  </li>
                </ul>
            </div>
          </div>
          <div class="boxConts" v-if="tabsIndex==1">
            <div class="cos">
                <ul>
                  <li > 
                    <div class="name">商品名称(Product Name)：</div>
                    <div class="dev">LJL Stainless Steel Bread Machine, 2LB 17-in-1 Programmable XL，Nonstick PanBread Maker</span></div>
                  </li>
                  <li> 
                    <div class="name">制造商(Manufacturer)：</div>
                    <div class="dev">LJL</div>
                  </li>
                  <li> 
                    <div class="name">品牌名称(Brand Name)：</div>
                    <div class="dev">LJL</div>
                  </li>
                  <li> 
                    <div class="name">商品编码(Product ID)：</div>
                    <div class="dev">783971083806</div>
                  </li>
                  <li> 
                    <div class="name">商品编码类型：</div>
                    <div class="dev">upc</div>
                  </li>
                </ul>
            </div>
          </div>
          <div class="boxConts" v-if="tabsIndex==2">
            <div class="cos">
                <ul>
                  <li > 
                    <div class="name">卖家SKU(Seller SKU)：</div>
                    <div class="dev">Bread Machine1102</span></div>
                  </li>
                   <li > 
                  <div class="name">新旧程度（Item Condition）：</div>
                    <div class="dev">全新</div>
                  </li>
                  <li > 
                    <div class="name">商品价格(Standard Price)：</div>
                    <div class="dev">199.12</div>
                  </li>
                  <li > 
                    <div class="name">配送渠道：</div>
                    <div class="dev">亚马逊物流</div>
                  </li>
                </ul>
            </div>
          </div>
          <div class="boxConts" v-if="tabsIndex==3">
            <div class="cos">
                <ul>
                  <li> 
                    <div class="name">卖点 1(Key Product Features)：</div>
                    <div class="dev">[Intelligent Fruit and Nut Dispenser & Patented Non-stick Ceramic Pan]The detachable fruit nut dispenser releases the ingredients automatically at the optimum time. Ceramic Pan is designed to make the bread evenly baked and healthier for no chemicals.</div>
                  </li>
                  <li> 
                    <div class="name">卖点 2(Key Product Features)：</div>
                    <div class="dev">[Intuitive Digital Touch Panel Control & 15H Timer, 1H Automatic Warm-keeping Function]Intuitive touch-pad control is easy to use. 15-hour Delay Timer, 1-Hour Automatic Keep Warm, 15-minute Power Interruption Recovery allow for fresh breads anytime.</div>
                  </li>
                  <li> 
                    <div class="name">卖点 3(Key Product Features)：</div>
                    <div class="dev">[Sleek Stainless Steel Design for Healthy Freshly Baked Bread at Home]Attractive sleek stainless steel design and tempered glass cover blend in well with any kitchen décor. Homemade bread is not only tastier but also healthier (fresher & less chemicals).</div>
                  </li>
                  <li> 
                    <div class="name">卖点4(Key Product Features)：</div>
                    <div class="dev">[ETL Approved Durable Quality and 300 Free Recipes]KBS Bread Machine comes with 2-Year Warranty for all parts and accessories. Customer can contact Customer Service for A Master Baker's 300 Favorite Recipes via Email. We always reply within 24 hours.</div>
                  </li>
                  <li> 
                    <div class="name">卖点 5(Key Product Features)：</div>
                    <div class="dev">[2 LB Large Capacity & 17 Customized Automatic Programs]KBS Bread Maker has settings for light, medium or dark crust, different loaf capacity from 1, 1.5 and 2.2 lb. It also has 17 programs to choose from (QUICK BREAD, WHOLE-WHEAT, GLUTEN FREE, JAM, etc.)</div>
                  </li>
                  <li> 
                    <div class="name">商品描述(Product Description)：</div>
                    <div class="dev">Automatic Upgraded Bread Machine, Professional Bread maker with rich experience in the kitchen. A revolutionary heating element built into our KBS Breadmaker changes the way you can bake at home. With perfectly browned crust every time, anyone can be a master baker.Main Function:. 17 menus including Soft bread, Sweet bread, Natural sourdough, French bread, Whole wheat, Quick bread, Sugar-free, Multigrain, Milky loaf, Cake, Raw dough, Leaven dough, Jam, Bake, Yogurt, Gluten-free, Ferment, Rice wine, Stir-fry. 3 Crust colors - light, medium, dark. 3 Loaf sizes - 1.0/1.5/2.0 lb to bake a large traditional up to 2.2-pound loaf. 15-hour programmable Delay Bake, 1-hour Keep Warm and 15-minute Power Interruption Recovery allow you to come home or wake to the savoriness of a freshly baked loaf.</div>
                  </li>
                </ul>
            </div>
          </div>
          <div class="boxConts" v-if="tabsIndex==4">
            <div class="cos">
                <ul>
                  <li > 
                    <div class="name">搜索关键词(Search Terms)：</div>
                    <div class="dev">bread maker machine gluten free setting</span></div>
                  </li>
                </ul>
            </div>
          </div>
          <div class="boxConts" v-if="tabsIndex==5">
            <div class="cos">
                <ul>
                  <li class="list"> 
                    <img :src="interfaceJson.ipUrl+'/caseImg/mian.jpeg'" alt="">
                    <img :src="interfaceJson.ipUrl+'/caseImg/deputy1.jpeg'" alt="">
                    <img :src="interfaceJson.ipUrl+'/caseImg/deputy2.jpeg'" alt="">
                    <img :src="interfaceJson.ipUrl+'/caseImg/deputy3.jpeg'" alt="">
                    <img :src="interfaceJson.ipUrl+'/caseImg/deputy4.jpeg'" alt="">
                    <img :src="interfaceJson.ipUrl+'/caseImg/deputy5.jpeg'" alt="">
                    <img :src="interfaceJson.ipUrl+'/caseImg/deputy6.jpeg'" alt="">
                    <img :src="interfaceJson.ipUrl+'/caseImg/deputy7.jpeg'" alt="">
                    <img :src="interfaceJson.ipUrl+'/caseImg/deputy8.jpeg'" alt="">
                  </li>
                </ul>

            </div>
            <div class="btn" @click="allDown()"><img src="../../assets/images/olds.png" alt=""> 全部下载</div>
          </div>
        </div>
      </div>
      <div class="colsPop pyPop"  v-drag v-if="isVideo">
        <div class="colsCont">
          <div class="close" @click="isVideo=false;zwCont='';pingyinCont='';">
            <img src="../../assets/images/close.svg" >
          </div>
          <div class="head">
            <div class="uname">汉字转拼音</div>
          </div>
          <div class="input_wrap">
            <div class="ipt">
              <label >中文</label><input type="text" v-model="zwCont">
            </div>
            <div class="ipt">
              <label >拼音</label> <input type="text" v-model="pingyinCont">
            </div>
          </div>
          <div class="iBtn" @click="goPinyin">一键转换</div>
        </div>
      </div>
      <div class="pop_bg" v-if="reexamination"></div>
      <CommonPop :reexamination='reexamination' :scoreFun ='scoreFun' :textCommonPop='textCommonPop' ></CommonPop>
      <div class="tipsPop" v-if="tips">
      <div class="head">
          提示
          <div class="icon" @click="tips=false">
            <img src="../../assets/images/close.svg" >
          </div>
          <div class="co">
            <img src="../../assets/images/mark.png" alt="">
          </div>
          <div class="cont">
              您将要清空所有数据，确认是否继续
          </div>   
          <div class="btnWrap">
              <div class="btn" @click="deleteInfo()">是</div><div class="btnN" @click="tips=false">否</div>
          </div>
      </div>
    </div>
    <div class="pop_bg" v-if="isSelectPop"></div>
    <div class="selectPop" v-if="isSelectPop">
      <div class="title">
        恭喜您，已完成美国站模拟注册 
          <div class="close" @click="isSelectPop=false">
              <img src="../../assets/images/close.svg" >
          </div>
        </div>
      <div class="btn" @click="cancalChild('score')">
        查看填写参考
      </div>
    </div>
      <div class="pop_bg" v-if="isScore"></div>
      <div class="scorePop" v-if="isScore">
          <div class="head">
              <div class="el">
                  <div class="li avt">
                     <div class="num">{{thisScore}}</div> 
                     <div class="nx">目前得分</div>
                  </div>
                  <div class="li">
                     <div class="num">{{numScore}}</div> 
                     <div class="nx">目前总分</div>
                  </div>
              </div>
              <div class="ps">考核分数只是针对注册中的填写信息对错来衡量，不与实际注册成功与否挂钩！！！</div>
              <div class="btnScore" @click="tips=true">重新练习</div>
              <div class="close" @click="closeScore">
                <img src="../../assets/images/close.svg" >
              </div>
          </div>
          <div class="cont">
            <div class="titUl">
              <div class="li">注册信息</div>
              <div class="li fx4">填写内容</div>
              <div class="li">评分</div>
              <div class="li">结果</div>
              <div class="li fx4">填写信息知识点说明</div>
            </div>
            <div class="conList">
               <div class="titUl" v-for="(item,index) in infoScore" :key="index" :class="{avt:item.result==0}">
                <div class="li">{{item.name}}</div>
                <div class="li fx4">{{item.mcont}}</div>
                <div class="li">{{item.credit}}</div>
                <div class="li dP"><img :src="item.result==0?require('../../assets/images/Wrong.png'):require('../../assets/images/correct.png')" alt="">{{item.resultCont}}</div>
                <div class="li fx4">{{item.knowledgePoint}}</div>
              </div>
            </div>
          </div>
      </div>
    
  </div>
</template>
<script>
import CaseHead from '../../components/CaseHead/Index';
import CommonPop from '../../components/CommonPop/Index';
export default {
  name: "site",
  data: function() {
    return {
      tabs:[
        {name:"案例须知"},
        {name:"重要信息"},
        {name:"报价"},
        {name:"描述"},
        {name:"关键字"},
        {name:"图片"},
      ],
      tabsIndex:0,
      siteName:'单一产品上传',
      regPage:[
        {name:'上传商品-添加商品',mark:0,maxMark:0,stateOne:0,stateTwo:0,
          markList:[
            {name:'上传商品-添加商品',mark:0,maxMark:0}
          ]
        },
        {name:'上传商品-添加一个新产品',mark:0,maxMark:0,stateOne:0,stateTwo:0,
          markList:[
            {name:'上传商品-添加一个新产品',mark:0,maxMark:0}
            ]
        },
        {name:'选择商品类目',mark:0,maxMark:0,stateOne:0,stateTwo:0,
         markList:[
            {name:'商品类目-选择大类目',mark:0,maxMark:0},
            {name:'商品类目-选择类目',mark:0,maxMark:0},
            {name:'商品类目-选择小类目',mark:0,maxMark:0},
            {name:'商品类目-选择类别',mark:0,maxMark:0}
          ]
        },
        {name:'重要信息',mark:0,maxMark:0,stateOne:0,stateTwo:0,
          markList:[
            {name:'重要信息-标题',mark:0,maxMark:0},
            {name:'重要信息-制造商',mark:0,maxMark:0},
            {name:'重要信息-品牌',mark:0,maxMark:0},
            {name:'重要信息-ID',mark:0,maxMark:0},
            {name:'重要信息-产品标识编码',mark:0,maxMark:0}
          ]
        },
        {name:'报价',mark:0,maxMark:0,stateOne:0,stateTwo:0,
          markList:[
            {name:'报价-卖家SKU',mark:0,maxMark:0},
            {name:'报价-新旧程度',mark:0,maxMark:0},
            {name:'报价-价格',mark:0,maxMark:0},
            {name:'报价-配送方式',mark:0,maxMark:0}
            ]
        },
        {name:'图片',mark:0,maxMark:0,stateOne:0,stateTwo:0,
        markList:[
            {name:'图片-上传主图',mark:0,maxMark:0},
            {name:'图片-上传副图1',mark:0,maxMark:0},
            {name:'图片-上传副图2',mark:0,maxMark:0},
            {name:'图片-上传副图3',mark:0,maxMark:0},
            {name:'图片-上传副图4',mark:0,maxMark:0},
            {name:'图片-上传副图5',mark:0,maxMark:0},
            {name:'图片-上传副图6',mark:0,maxMark:0},
            {name:'图片-上传副图7',mark:0,maxMark:0},
            {name:'图片-上传副图8',mark:0,maxMark:0}
            ]
        },
        {name:'描述',mark:0,maxMark:0,stateOne:0,stateTwo:0,
        markList:[
            {name:'描述-卖点1',mark:0,maxMark:0},
            {name:'描述-卖点2',mark:0,maxMark:0},
            {name:'描述-卖点3',mark:0,maxMark:0},
            {name:'描述-卖点4',mark:0,maxMark:0},
            {name:'描述-卖点5',mark:0,maxMark:0},
            {name:'描述-商品描述',mark:0,maxMark:0}
            ]
        },
        {name:'关键字',mark:0,maxMark:0,stateOne:0,stateTwo:0,
         markList:[
            {name:'关键字-搜索关键词',mark:0,maxMark:0}
            ]
        },
        {name:'上传完成',mark:0,maxMark:0,stateOne:0,stateTwo:0}
        ],
      numScore:0,
      thisScore:0,
      zwCont:'',
      isLeasing:'',
      pingyinCont:'',
      isPingyin:false,
      isSelectPop:false,
      numScores:null,
      textCommonPop:'',
      infoScore:[],
      reexamination:false,
      isHelpShow:false,
      isScore:false,
      isVideo:false,
      isChisShow:false,
      iframeHeight:null,
      isHelp:true,
      isChis:true,
      AccountInfo:false,
      VirtualInfo:{},
      iframeWin: {},
      tips:false,
      jsonMrck:[
          { "key": "addProducts", "credit": 0, "value": "" },
          { "key": "needAddOne", "credit": 0, "value": "" },
          { "key": "category1", "credit": 0, "value": "" },
          { "key": "category2", "credit": 0, "value": "" },
          { "key": "category3", "credit": 0, "value": "" },
          { "key": "category4", "credit": 0, "value": "" },
          { "key": "ProductName", "credit": 0, "value": "" },
          { "key": "Manufacturer", "credit": 0, "value": "" },
          { "key": "BrandName", "credit": 0, "value": "" },
          { "key": "ProductID", "credit": 0, "value": "" },
          { "key": "ProductType", "credit": 0, "value": "" },
          { "key": "SellerSKU", "credit": 0, "value": "" },
          { "key": "ItemCondition", "credit": 0, "value": "" },
          { "key": "StandardPrice", "credit": 0, "value": "" },
          { "key": "transportationChannel", "credit": 0, "value": "" },
          { "key": "judgeMAIN", "credit": 0, "value": "" },
          { "key": "judgeProductImagePT01", "credit": 0, "value": "" },
          { "key": "judgeProductImagePT02", "credit": 0, "value": "" },
          { "key": "judgeProductImagePT03", "credit": 0, "value": "" },
          { "key": "judgeProductImagePT04", "credit": 0, "value": "" },
          { "key": "judgeProductImagePT05", "credit": 0, "value": "" },
          { "key": "judgeProductImagePT06", "credit": 0, "value": "" },
          { "key": "judgeProductImagePT07", "credit": 0, "value": "" },
          { "key": "judgeProductImagePT08", "credit": 0, "value": "" },
          { "key": "productFeaturesOne", "credit": 0, "value": "" },
          { "key": "productFeaturesTwo", "credit": 0, "value": "" },
          { "key": "productFeaturesThree", "credit": 0, "value": "" },
          { "key": "productFeaturesFour", "credit": 0, "value": "" },
          { "key": "productFeaturesFive", "credit": 0, "value": "" },
          { "key": "productDescribe", "credit": 0, "value": "" },
          { "key": "SearchTerms", "credit": 0, "value": "" }],
      stepNum:0,
      mPage:'',
      view:{
         src:'http://120.78.89.173/admin/sellercentral.html',
      },
      regInfo:{},
      AmazonRegAccountInfo:{},
      chis:'0',
      help:'0'
    };
  },
 //注册局部组件指令
  directives: {
      drag: function(el) {
          let dragDiv = el; //获取当前元素
          dragDiv.addEventListener("mousedown", function(e) {
             if(e.target.className=='de' || e.target.className== 'uname'){
              //获取div初始位置对象
              var divRect = dragDiv.getBoundingClientRect();
              //获取鼠标点击的位置
              var downX = e.clientX;
              var downY = e.clientY;
              //开关打开
              var startMove = true;
              //设置样式为移动光标
              dragDiv.style.cursor = "move";
              window.onmousemove = function(e) {
              if (!startMove) {
              return;
              }
              let newLeft = e.clientX - downX + divRect.left;
              let newTop = e.clientY - downY + divRect.top;
              dragDiv.style.left = newLeft + "px";
              dragDiv.style.top = newTop + "px";
              return false;
              };
              window.onmouseup = function(e) {
              //结束移动
              startMove = false;
              dragDiv.style.cursor = "default";
              return false;
              };

              e.stopPropagation();
             }
        });
      }
  },
  mounted () {
    /* eslint-disable */
    let oIframe = document.getElementById('bdIframe');
    let regInfoJson={};
      // 在外部vue的window上添加postMessage的监听，并且绑定处理函数handleMessage
      window.addEventListener('message', event => {
            // 根据上面制定的结构来解析iframe内部发回来的数据
          const data = event.data
          try { 
            if(data){
              // console.log("111")
              this.getScoreList()
              // if()
              if(data.eqIndex!=null){
                if(data.eqIndex==1||data.eqIndex==3||data.eqIndex==7||data.eqIndex==10){
                  this.isHelp=false
                  this.isChis=false
                }
                if(data.eqIndex==1||data.eqIndex==3||data.eqIndex==7)return
                switch (data.eqIndex) {
                  case 0:
                    this.stepNum =3
                     this.goRegPage(this.stepNum)
                    break;
                  case 2:
                    this.stepNum =4
                     this.goRegPage(this.stepNum)
                      break;
                  case 4:
                    this.stepNum =5
                     this.goRegPage(this.stepNum)
                      break;
                  case 5:
                    this.stepNum =6
                     this.goRegPage(this.stepNum)
                      break; 
                  case 6:
                    this.stepNum =7
                     this.goRegPage(this.stepNum)
                    break;
                  case 11:
                    this.stepNum =2
                     this.goRegPage(this.stepNum)
                   break;
                  case 8:
                    this.stepNum =3
                     this.goRegPage(this.stepNum)
                  break;  
                   case 9:
                    this.stepNum =1
                     this.goRegPage(this.stepNum)
                  break; 
                   case 10:
                    this.stepNum =8
                     this.goRegPage(this.stepNum)
                    this.isScore=true;
                  break; 
                }
               
              }
              if(data=='creditok'){
                if(sessionStorage.getItem('zsMode')!=9){
                   this.isSelectPop=true;
                }
              }
             if(data.iframeHeight){
               this.isChisShow=false;
               this.isHelpShow=false;
               this.help='0'
               this.chis='0'
              
              }
              if(data.mPage){
                this.mPage=data.mPage
              }
              if(data.chis==0){
                this.isChisShow=false;
              }
              if(data.help==0){
                  this.isHelpShow=false;
              }
            }
            
        } catch(err) {
        }
          
        });
      this.iframeWin = this.$refs.iframe.contentWindow;
    },
    computed: {
        user() {
          return this.$store.getters.user;
        },
  },
   watch: {
  },
  created(){
    this.odCreditArr()
    this.getHistory()
    this.getBeforeAmazonRegAccountInfo()
    sessionStorage.ASIN = ""
    sessionStorage.shopDate = ""
    sessionStorage.regMarketArr = JSON.stringify([
        { "regInfo": "上传商品-添加商品", "credit": 2, "correctShow": "选择正确", "errorShow": "选择错误", "knowledgePoint": "单一上传商品菜单进入口" },
        { "regInfo": "上传商品-添加一个新产品", "credit": 1, "correctShow": "选择正确", "errorShow": "选择错误", "knowledgePoint": "选择“我要添加未在亚马逊上销售的新商品”" },
        { "regInfo": "商品类目-选择大类目", "credit": 2, "correctShow": "选择正确", "errorShow": "选择错误", "knowledgePoint": "选择内容为商品类目-大类目" },
        { "regInfo": "商品类目-选择类目", "credit": 2, "correctShow": "选择正确", "errorShow": "选择错误", "knowledgePoint": "选择内容为商品类目-类目" },
        { "regInfo": "商品类目-选择小类目", "credit": 2, "correctShow": "选择正确", "errorShow": "选择错误", "knowledgePoint": "选择内容为商品类目-小类目" },
        { "regInfo": "商品类目-选择类别", "credit": 2, "correctShow": "选择正确", "errorShow": "选择错误", "knowledgePoint": "选择内容为商品类目-类别" },
        { "regInfo": "重要信息-标题", "credit": 8, "correctShow": "填写正确", "errorShow": "填写错误", "knowledgePoint": "填写内容为商品的标题，限定字符为250" },
        { "regInfo": "重要信息-制造商", "credit": 6, "correctShow": "填写正确", "errorShow": "填写错误", "knowledgePoint": "填写内容为商品的制造商名称" },
        { "regInfo": "重要信息-品牌", "credit": 8, "correctShow": "填写正确", "errorShow": "填写错误", "knowledgePoint": "填写内容为商品的品牌名称" },
        { "regInfo": "重要信息-ID", "credit": 6, "correctShow": "填写正确", "errorShow": "填写错误", "knowledgePoint": "填写内容为商品编码" },
        { "regInfo": "重要信息-产品标识编码", "credit": 2, "correctShow": "选择正确", "errorShow": "选择错误", "knowledgePoint": "选择内容为产品唯一标识编码的分类" },
        { "regInfo": "报价-卖家SKU", "credit": 5, "correctShow": "填写正确", "errorShow": "填写错误", "knowledgePoint": "填写内容为卖家SKU" },
        { "regInfo": "报价-新旧程度", "credit": 2, "correctShow": "选择正确", "errorShow": "选择错误", "knowledgePoint": "选择内容为产品的新旧程度" },
        { "regInfo": "报价-价格", "credit": 8, "correctShow": "填写正确", "errorShow": "填写错误", "knowledgePoint": "填写内容为商品价格" },
        { "regInfo": "报价-配送方式", "credit": 2, "correctShow": "选择正确", "errorShow": "选择错误", "knowledgePoint": "选择内容为FBA配送" },
        { "regInfo": "图片-上传主图", "credit": 2, "correctShow": "上传正确", "errorShow": "上传错误", "knowledgePoint": "上传内容为产品主图，格式为JPEG 、TIFF 、GIF图片" },
        { "regInfo": "图片-上传副图1", "credit": 2, "correctShow": "上传正确", "errorShow": "上传错误", "knowledgePoint": "上传内容为产品副图1，格式为JPEG 、TIFF 、GIF图片" },
        { "regInfo": "图片-上传副图2", "credit": 2, "correctShow": "上传正确", "errorShow": "上传错误", "knowledgePoint": "上传内容为产品副图2，格式为JPEG 、TIFF 、GIF图片" },
        { "regInfo": "图片-上传副图3", "credit": 2, "correctShow": "上传正确", "errorShow": "上传错误", "knowledgePoint": "上传内容为产品副图3，格式为JPEG 、TIFF 、GIF图片" },
        { "regInfo": "图片-上传副图4", "credit": 2, "correctShow": "上传正确", "errorShow": "上传错误", "knowledgePoint": "上传内容为产品副图4，格式为JPEG 、TIFF 、GIF图片" },
        { "regInfo": "图片-上传副图5", "credit": 2, "correctShow": "上传正确", "errorShow": "上传错误", "knowledgePoint": "上传内容为产品副图5，格式为JPEG 、TIFF 、GIF图片" },
        { "regInfo": "图片-上传副图6", "credit": 2, "correctShow": "上传正确", "errorShow": "上传错误", "knowledgePoint": "上传内容为产品副图6，格式为JPEG 、TIFF 、GIF图片" },
        { "regInfo": "图片-上传副图7", "credit": 2, "correctShow": "上传正确", "errorShow": "上传错误", "knowledgePoint": "上传内容为产品副图7，格式为JPEG 、TIFF 、GIF图片" },
        { "regInfo": "图片-上传副图8", "credit": 2, "correctShow": "上传正确", "errorShow": "上传错误", "knowledgePoint": "上传内容为产品副图8，格式为JPEG 、TIFF 、GIF图片" },
        { "regInfo": "描述-卖点1", "credit": 3, "correctShow": "填写正确", "errorShow": "填写错误", "knowledgePoint": "填写内容为商品卖点或产品主要功能1" },
        { "regInfo": "描述-卖点2", "credit": 3, "correctShow": "填写正确", "errorShow": "填写错误", "knowledgePoint": "填写内容为商品卖点或产品主要功能2" },
        { "regInfo": "描述-卖点3", "credit": 3, "correctShow": "填写正确", "errorShow": "填写错误", "knowledgePoint": "填写内容为商品卖点或产品主要功能3" },
        { "regInfo": "描述-卖点4", "credit": 3, "correctShow": "填写正确", "errorShow": "填写错误", "knowledgePoint": "填写内容为商品卖点或产品主要功能4" },
        { "regInfo": "描述-卖点5", "credit": 3, "correctShow": "填写正确", "errorShow": "填写错误", "knowledgePoint": "填写内容为商品卖点或产品主要功能5" },
        { "regInfo": "描述-商品描述", "credit": 5, "correctShow": "填写正确", "errorShow": "填写错误", "knowledgePoint": "填写内容为商品的描述" },
        { "regInfo": "关键字-搜索关键词", "credit": 4, "correctShow": "填写正确", "errorShow": "填写错误", "knowledgePoint": "填写内容为商品的搜索关键词" },
    ])
    sessionStorage.caseInfo = JSON.stringify({
        "商品类目1英文": "Home & Kitchen",
        "商品类目1中文": "家居与厨房",
        "商品类目2英文": "Kitchen & Dining",
        "商品类目2中文": "厨房和餐厅",
        "商品类目3英文": "Small Appliances",
        "商品类目3中文": "小家电",
        "商品类目4英文": "Bread Machines",
        "商品类目4中文": "面包机",
        "商品名称": "LJL Stainless Steel Bread Machine, 2LB 17-in-1 Programmable XL，Nonstick PanBread Maker",
        "制造商": "LJL",
        "品牌名称": "LJL",
        "商品编码": "783971083806",
        "卖家SKU": "Bread Machine1102",
        "商品价格": "199.12",
        "商品编码类型": "upc",
        "新旧程度": "new, new",
        "商品描述": "Automatic Upgraded Bread Machine, Professional Bread maker with rich experience in the kitchen. A revolutionary heating element built into our KBS Breadmaker changes the way you can bake at home. With perfectly browned crust every time, anyone can be a master baker.Main Function:. 17 menus including Soft bread, Sweet bread, Natural sourdough, French bread, Whole wheat, Quick bread, Sugar-free, Multigrain, Milky loaf, Cake, Raw dough, Leaven dough, Jam, Bake, Yogurt, Gluten-free, Ferment, Rice wine, Stir-fry. 3 Crust colors - light, medium, dark. 3 Loaf sizes - 1.0/1.5/2.0 lb to bake a large traditional up to 2.2-pound loaf. 15-hour programmable Delay Bake, 1-hour Keep Warm and 15-minute Power Interruption Recovery allow you to come home or wake to the savoriness of a freshly baked loaf.",
        "描述信息1": "[Intelligent Fruit and Nut Dispenser & Patented Non-stick Ceramic Pan]The detachable fruit nut dispenser releases the ingredients automatically at the optimum time. Ceramic Pan is designed to make the bread evenly baked and healthier for no chemicals.",
        "描述信息2": "[Intuitive Digital Touch Panel Control & 15H Timer, 1H Automatic Warm-keeping Function]Intuitive touch-pad control is easy to use. 15-hour Delay Timer, 1-Hour Automatic Keep Warm, 15-minute Power Interruption Recovery allow for fresh breads anytime.",
        "描述信息3": "[Sleek Stainless Steel Design for Healthy Freshly Baked Bread at Home]Attractive sleek stainless steel design and tempered glass cover blend in well with any kitchen décor. Homemade bread is not only tastier but also healthier (fresher & less chemicals).",
        "描述信息4": "[ETL Approved Durable Quality and 300 Free Recipes]KBS Bread Machine comes with 2-Year Warranty for all parts and accessories. Customer can contact Customer Service for A Master Baker's 300 Favorite Recipes via Email. We always reply within 24 hours.",
        "描述信息5": "[2 LB Large Capacity & 17 Customized Automatic Programs]KBS Bread Maker has settings for light, medium or dark crust, different loaf capacity from 1, 1.5 and 2.2 lb. It also has 17 programs to choose from (QUICK BREAD, WHOLE-WHEAT, GLUTEN FREE, JAM, etc.)",
        "搜索关键词": "bread maker machine gluten free setting",
        "主图": "F32F405C5C3649CA64824FB9664E7BDB",
        "副图1": "11F31590A253F61AEF2E5B9E029F968E",
        "副图2": "5AF6FB3E22E2EC59BB95F94F00DEFE75",
        "副图3": "4CFF2264062F54DE1746FC398524588B",
        "副图4": "AF37C8909BEC77167F2A3887ECDE66C2",
        "副图5": "095735137B9A5769A1F14F7E3ABD1F08",
        "副图6": "1BB5EFCB226AF86B3C15632799E796FD",
        "副图7": "B96A16EE571DFF6A693C3537CAF5192D",
        "副图8": "C287AC103C220956514C4CA19D46F44B",
    })
    sessionStorage.category4EN=null;
    sessionStorage.multilingual = 0
    sessionStorage.creditMarket = 0;
  },
  methods: {
      tabsClick(index){
        this.tabsIndex=index;
      },
      odCreditArr(){
        sessionStorage.creditArr = JSON.stringify([{ "key": "addProducts", "credit": 0, "value": "" },
          { "key": "needAddOne", "credit": 0, "value": "" },
          { "key": "category1", "credit": 0, "value": "" },
          { "key": "category2", "credit": 0, "value": "" },
          { "key": "category3", "credit": 0, "value": "" },
          { "key": "category4", "credit": 0, "value": "" },
          { "key": "ProductName", "credit": 0, "value": "" },
          { "key": "Manufacturer", "credit": 0, "value": "" },
          { "key": "BrandName", "credit": 0, "value": "" },
          { "key": "ProductID", "credit": 0, "value": "" },
          { "key": "ProductType", "credit": 0, "value": "" },
          { "key": "SellerSKU", "credit": 0, "value": "" },
          { "key": "ItemCondition", "credit": 0, "value": "" },
          { "key": "StandardPrice", "credit": 0, "value": "" },
          { "key": "transportationChannel", "credit": 2, "value": 1 },
          { "key": "judgeMAIN", "credit": 0, "value": "" },
          { "key": "judgeProductImagePT01", "credit": 0, "value": "" },
          { "key": "judgeProductImagePT02", "credit": 0, "value": "" },
          { "key": "judgeProductImagePT03", "credit": 0, "value": "" },
          { "key": "judgeProductImagePT04", "credit": 0, "value": "" },
          { "key": "judgeProductImagePT05", "credit": 0, "value": "" },
          { "key": "judgeProductImagePT06", "credit": 0, "value": "" },
          { "key": "judgeProductImagePT07", "credit": 0, "value": "" },
          { "key": "judgeProductImagePT08", "credit": 0, "value": "" },
          { "key": "productFeaturesOne", "credit": 0, "value": "" },
          { "key": "productFeaturesTwo", "credit": 0, "value": "" },
          { "key": "productFeaturesThree", "credit": 0, "value": "" },
          { "key": "productFeaturesFour", "credit": 0, "value": "" },
          { "key": "productFeaturesFive", "credit": 0, "value": "" },
          { "key": "productDescribe", "credit": 0, "value": "" },
          { "key": "SearchTerms", "credit": 0, "value": "" }])
      },
      goRegPage(e){
          this.regPage[e].stateOne=1
          this.stepNum=e
          this.isHelp=true
          this.isChis=true
          this.history(e)
          this.isChisShow=false;
          switch (e) {
            case 0:
              this.view.src=this.interfaceJson.ipUrl+'/admin/sellercentral.html'
              break;
            case 1:
              this.view.src=this.interfaceJson.ipUrl+'/admin/P1.html'
              break;
            case 2:
              this.view.src=this.interfaceJson.ipUrl+'/admin/P2.html'
                break;
            case 3:
              this.view.src=this.interfaceJson.ipUrl+'/admin/P3.html'//tab1
              this.iframeWin.postMessage({
              eq:0
              }, '*') 
              break;
            case 4:
              this.view.src=this.interfaceJson.ipUrl+'/admin/P3.html'//tab2
              // console.log("111")
              setTimeout(()=>{
                this.iframeWin.postMessage({
                eq:2
                }, '*') 
              },600)
                break;
            case 5:
              this.view.src=this.interfaceJson.ipUrl+'/admin/P3.html'//tab3
              setTimeout(()=>{
                this.iframeWin.postMessage({
                eq:4
                }, '*') 
               },600)
                break;
            case 6:
              this.view.src=this.interfaceJson.ipUrl+'/admin/P3.html'//tab4
              setTimeout(()=>{
                this.iframeWin.postMessage({
                eq:5
                }, '*') 
               },600)
                break; 
            case 7:
              this.view.src=this.interfaceJson.ipUrl+'/admin/P3.html'
                setTimeout(()=>{
                   this.iframeWin.postMessage({
                    eq:6
                    }, '*')
                },600)
                break; 
            case 8:
                this.view.src=this.interfaceJson.ipUrl+'/admin/P4.html'
                this.isHelp=false
                this.isChis=false
                break; 
         }
      },
      goPinyin(){
        if(this.zwCont){
          this.pingyinCont= this.getPinyin(this.zwCont).trim()
        }
      },
      history(e){
          this.$axios
          .post(this.interfaceJson.serverAddress+"/api/site_case/history",e)
          .then(res => {
          let data=res.data;
          if(data.code==0){

          }else{
            
          }
          });
      },
       getHistory(){
        this.$axios
        .get(this.interfaceJson.serverAddress+"/api/site_case/history")
        .then(res => {
          let data=res.data;
          if(data.code==0){
            if(data.data){
               data.data.map(item=>{
                this.regPage[Number(item)].stateOne=1
              })
            }
           
          }
        })
      },
      deleteInfo(e){
          this.$axios
          .post(this.interfaceJson.serverAddress+"/api/site_case/restart")
          .then(res => {
          let data=res.data;
          if(data.code==0){
            this.odCreditArr()
            location.reload()
          }else{
            
          }
          });
      },
      scoreFun(e){
      // 继续操作
        if(e=='1'){
           if(this.AmazonRegAccountInfo.step==13){
            this.view.src=this.interfaceJson.ipUrl+'/N-siteUs/us/reg13_us.html'
          }else{
            this.goStep()
          }
          this.reexamination=false
        }
        if(e=='0'){
          if(this.user.zs==9){
              this.view.src=this.interfaceJson.ipUrl+'/admin/sellercentral.html'
          }else{
            this.deleteInfo()
          }
        }
      },
      closeScore(){
        this.infoScore=[];
        this.isScore=false;
      },
      getBeforeAmazonRegAccountInfo(){
         this.$axios
        .get(this.interfaceJson.serverAddress+"/api/site_case/getBeforeCaseAmazonRegAccountInfo")
        .then(res => {
          let data=res.data;
          if(data.code==0){
            let dataList=data.data
            this.stepNum=dataList.step
             this.goRegPage(this.stepNum)
            if(dataList){
                if(dataList.caseAddProductsEntity){
                  //  上传商品-添加商品
                  if(dataList.caseAddProductsEntity.addProducts){
                    this.jsonMrck[0].value=dataList.caseAddProductsEntity.addProducts==0?"true":""
                  }
                }
                if(dataList.caseNeedProductsEntity){
                  //  上传商品-添加一个新产品
                  if(dataList.caseNeedProductsEntity.needAddOne){
                    this.jsonMrck[1].value=dataList.caseNeedProductsEntity.needAddOne==0?"true":""
                  }
                }
                 if(dataList.caseProductCategoryEntity){
                  //  商品类目-选择大类目
                  if(dataList.caseProductCategoryEntity.bigProductCategory){
                    this.jsonMrck[2].value=dataList.caseProductCategoryEntity.bigProductCategory
                  }
                   //  商品类目-选择类目
                  if(dataList.caseProductCategoryEntity.productCategory){
                    this.jsonMrck[3].value=dataList.caseProductCategoryEntity.productCategory
                  }
                   //  商品类目-选择小类目
                  if(dataList.caseProductCategoryEntity.smallProductCategory){
                    this.jsonMrck[4].value=dataList.caseProductCategoryEntity.smallProductCategory
                  }
                  //  商品类目-选择类别
                  if(dataList.caseProductCategoryEntity.product){
                    this.jsonMrck[5].value=dataList.caseProductCategoryEntity.product
                  }
                }
                if(dataList.caseImportantInfoEntity){
                  // console.log(dataList.caseImportantInfoEntity)                  
                  //  重要信息-标题
                  if(dataList.caseImportantInfoEntity.productName){
                    this.jsonMrck[6].value=dataList.caseImportantInfoEntity.productName
                  }
                  //  重要信息-制造商
                  if(dataList.caseImportantInfoEntity.manufacturer){
                    this.jsonMrck[7].value=dataList.caseImportantInfoEntity.manufacturer
                  }
                  //  重要信息-品牌
                  if(dataList.caseImportantInfoEntity.brandName){
                    this.jsonMrck[8].value=dataList.caseImportantInfoEntity.brandName
                  }
                  //  重要信息-ID
                  if(dataList.caseImportantInfoEntity.productId){
                    this.jsonMrck[9].value=dataList.caseImportantInfoEntity.productId
                  }
                   //  重要信息-产品标识编码
                  if(dataList.caseImportantInfoEntity.productCode){
                    this.jsonMrck[10].value=dataList.caseImportantInfoEntity.productCode
                  }
                }
              if(dataList.caseOfferEntity){
                  //  报价-卖家SKU
                  if(dataList.caseOfferEntity.sellerSku){
                    this.jsonMrck[11].value=dataList.caseOfferEntity.sellerSku
                  }
                  //  报价-新旧程度
                  if(dataList.caseOfferEntity.itemCondition){
                    this.jsonMrck[12].value=dataList.caseOfferEntity.itemCondition
                  }
                  //  报价-价格
                  if(dataList.caseOfferEntity.itemPrice){
                    this.jsonMrck[13].value=dataList.caseOfferEntity.itemPrice
                  }
                  //  报价-配送方式
                  if(dataList.caseOfferEntity.transportationChannel){
                    this.jsonMrck[14].value=dataList.caseOfferEntity.transportationChannel
                  }
              }  
              if(dataList.caseImageUploadEntity){
                  //  图片-上传主图
                  if(dataList.caseImageUploadEntity.productImageMain){
                    this.jsonMrck[15].value=dataList.caseImageUploadEntity.productImageMain
                  }
                  //  图片-上传副图1
                  if(dataList.caseImageUploadEntity.productImageOne){
                    this.jsonMrck[16].value=dataList.caseImageUploadEntity.productImageOne
                  }
                  //  图片-上传副图2
                  if(dataList.caseImageUploadEntity.productImageTwo){
                    this.jsonMrck[17].value=dataList.caseImageUploadEntity.productImageTwo
                  }
                  //  图片-上传副图3
                  if(dataList.caseImageUploadEntity.productImageThree){
                    this.jsonMrck[18].value=dataList.caseImageUploadEntity.productImageThree
                  }
                   //  图片-上传副图4
                  if(dataList.caseImageUploadEntity.productImageFour){
                    this.jsonMrck[19].value=dataList.caseImageUploadEntity.productImageFour
                  }
                   //  图片-上传副图5
                  if(dataList.caseImageUploadEntity.productImageFive){
                    this.jsonMrck[20].value=dataList.caseImageUploadEntity.productImageFive
                  }
                   //  图片-上传副图6
                  if(dataList.caseImageUploadEntity.productImageSix){
                    this.jsonMrck[21].value=dataList.caseImageUploadEntity.productImageSix
                  }
                   //  图片-上传副图7
                  if(dataList.caseImageUploadEntity.productImageSeven){
                    this.jsonMrck[22].value=dataList.caseImageUploadEntity.productImageSeven
                  }
                   //  图片-上传副图8
                  if(dataList.caseImageUploadEntity.productImageEight){
                    this.jsonMrck[23].value=dataList.caseImageUploadEntity.productImageEight
                  }
              }  
              if(dataList.caseFeaturesEntity){
                  //  描述-卖点1
                  if(dataList.caseFeaturesEntity.productFeaturesOne){
                    this.jsonMrck[24].value=dataList.caseFeaturesEntity.productFeaturesOne
                  }
                  //  描述-卖点2
                  if(dataList.caseFeaturesEntity.productFeaturesTwo){
                    this.jsonMrck[25].value=dataList.caseFeaturesEntity.productFeaturesTwo
                  }
                  //  描述-卖点3
                  if(dataList.caseFeaturesEntity.productFeaturesThree){
                    this.jsonMrck[26].value=dataList.caseFeaturesEntity.productFeaturesThree
                  }
                  //  描述-卖点4
                  if(dataList.caseFeaturesEntity.productFeaturesFour){
                    this.jsonMrck[27].value=dataList.caseFeaturesEntity.productFeaturesFour
                  }
                  //  描述-卖点5
                  if(dataList.caseFeaturesEntity.productFeaturesFive){
                    this.jsonMrck[28].value=dataList.caseFeaturesEntity.productFeaturesFive
                  }
                   //  描述-商品描述
                  if(dataList.caseFeaturesEntity.productDescribe){
                    this.jsonMrck[29].value=dataList.caseFeaturesEntity.productDescribe
                  }
              }  
              if(dataList.caseKeywordEntity){
                 // 关键字-搜索关键词
                  if(dataList.caseKeywordEntity.searchKeywords){
                    this.jsonMrck[30].value=dataList.caseKeywordEntity.searchKeywords
                  }
              }  
            }
             sessionStorage.creditArr = JSON.stringify(this.jsonMrck)
          }
        })
      },
      allDown(){
        this.downloadCodeImg(0)
      },
      downloadCodeImg(e){
          var a = document.createElement('a')
          a.download = '面包机图片素材'
          a.href = this.interfaceJson.ipUrl+'/面包机图片素材.zip';
          a.click();
      },
      getScoreList(){
        // console.log('111')
        let creditArr=null;
        if(sessionStorage.creditArr){
          creditArr= JSON.parse(sessionStorage.creditArr);
        }
        this.numScore=0;
        this.thisScore=0;
        this.regPage[0].maxMark=0
        this.regPage[0].markList[0].maxMark=0
        this.regPage[0].mark=0
        this.regPage[0].markList[0].mark=0
        this.regPage[1].maxMark=0
        this.regPage[1].markList[0].maxMark=0
        this.regPage[1].mark=0
        this.regPage[1].markList[0].mark=0
        this.regPage[2].maxMark=0
        this.regPage[2].mark=0
        this.regPage[2].markList[0].maxMark=0
        this.regPage[2].markList[0].mark=0
        this.regPage[2].markList[1].maxMark=0
        this.regPage[2].markList[1].mark=0
        this.regPage[2].markList[2].maxMark=0
        this.regPage[2].markList[2].mark=0
        this.regPage[2].markList[3].maxMark=0
        this.regPage[2].markList[3].mark=0
        this.regPage[3].maxMark=0
        this.regPage[3].mark=0
        this.regPage[3].markList[0].maxMark=0
        this.regPage[3].markList[0].mark=0
        this.regPage[3].markList[1].maxMark=0
        this.regPage[3].markList[1].mark=0
        this.regPage[3].markList[2].maxMark=0
        this.regPage[3].markList[2].mark=0
        this.regPage[3].markList[3].maxMark=0
        this.regPage[3].markList[3].mark=0
        this.regPage[3].markList[4].maxMark=0
        this.regPage[3].markList[4].mark=0
        this.regPage[4].maxMark=0
        this.regPage[4].mark=0
        this.regPage[4].markList[0].maxMark=0
        this.regPage[4].markList[0].mark=0
        this.regPage[4].markList[1].maxMark=0
        this.regPage[4].markList[1].mark=0
        this.regPage[4].markList[2].maxMark=0
        this.regPage[4].markList[2].mark=0
        this.regPage[4].markList[3].maxMark=0
        this.regPage[4].markList[3].mark=0
        this.regPage[5].maxMark=0
        this.regPage[5].mark=0
        this.regPage[5].markList[0].maxMark=0
        this.regPage[5].markList[0].mark=0
        this.regPage[5].markList[1].maxMark=0
        this.regPage[5].markList[1].mark=0
        this.regPage[5].markList[2].maxMark=0
        this.regPage[5].markList[2].mark=0
        this.regPage[5].markList[3].maxMark=0
        this.regPage[5].markList[3].mark=0
        this.regPage[5].markList[4].maxMark=0
        this.regPage[5].markList[4].mark=0
        this.regPage[5].markList[5].maxMark=0
        this.regPage[5].markList[5].mark=0
        this.regPage[5].markList[6].maxMark=0
        this.regPage[5].markList[6].mark=0
        this.regPage[5].markList[7].maxMark=0
        this.regPage[5].markList[7].mark=0
        this.regPage[5].markList[8].maxMark=0
        this.regPage[5].markList[8].mark=0
        this.regPage[6].maxMark=0
        this.regPage[6].mark=0
        this.regPage[6].markList[0].maxMark=0
        this.regPage[6].markList[0].mark=0
        this.regPage[6].markList[1].maxMark=0
        this.regPage[6].markList[1].mark=0
        this.regPage[6].markList[2].maxMark=0
        this.regPage[6].markList[2].mark=0
        this.regPage[6].markList[3].maxMark=0
        this.regPage[6].markList[3].mark=0
        this.regPage[6].markList[4].maxMark=0
        this.regPage[6].markList[4].mark=0
        this.regPage[6].markList[5].maxMark=0
        this.regPage[6].markList[5].mark=0
        this.regPage[7].maxMark=0
        this.regPage[7].mark=0
        this.regPage[7].markList[0].maxMark=0
        this.regPage[7].markList[0].mark=0
        this.infoScore=[];
        //  上传商品-添加商品
        this.markFun(0,0,0,creditArr[0].value=="true"?"选择正确":"选择错误",creditArr[0].value=="true")
        // 上传商品-添加一个新产品
        this.markFun(1,1,0,creditArr[1].value=="true"?"选择正确":"选择错误",creditArr[1].value=="true")
        // 商品类目-选择大类目
        this.markFun(2,2,0,creditArr[2].value? creditArr[2].value:'选择错误',creditArr[2].value)
        // 商品类目-选择类目
        this.markFun(3,2,1,creditArr[3].value? creditArr[3].value:'选择错误',creditArr[3].value)
        // 商品类目-选择小类目
        this.markFun(4,2,2,creditArr[4].value? creditArr[4].value:'选择错误',creditArr[4].value)
        // 商品类目-选择类别
        this.markFun(5,2,3,creditArr[5].value? creditArr[5].value:'选择错误',creditArr[5].value)
        // 重要信息-标题
        this.markFun(6,3,0,creditArr[6].value||"没有填写",this.compare_nospaces(creditArr[6].value,JSON.parse(sessionStorage.caseInfo).商品名称))
        // 重要信息-制造商
        this.markFun(7,3,1,creditArr[7].value||"没有填写",creditArr[7].value==JSON.parse(sessionStorage.caseInfo).制造商)
        // 重要信息-品牌
        this.markFun(8,3,2,creditArr[8].value||"没有填写",creditArr[8].value==JSON.parse(sessionStorage.caseInfo).品牌名称)
        // 重要信息-ID
        this.markFun(9,3,3,creditArr[9].value||"没有填写",creditArr[9].value== JSON.parse(sessionStorage.caseInfo).商品编码)
        // 重要信息-产品标识编码
        this.markFun(10,3,4,creditArr[10].value||"选择错误",creditArr[10].value== JSON.parse(sessionStorage.caseInfo).商品编码类型)
        // 报价-卖家SKU
        this.markFun(11,4,0,creditArr[11].value||"没有填写",this.compare_nospaces(creditArr[11].value,JSON.parse(sessionStorage.caseInfo).卖家SKU))
        // 报价-新旧程度
        this.markFun(12,4,1,creditArr[12].value||"选择错误",creditArr[12].value==JSON.parse(sessionStorage.caseInfo).新旧程度)
        // 报价-价格
        this.markFun(13,4,2,creditArr[13].value||"没有填写",creditArr[13].value==JSON.parse(sessionStorage.caseInfo).商品价格)
        // 报价-配送方式
        this.markFun(14,4,3,creditArr[14].value==1? "亚马逊配送":'卖家自行配送',creditArr[14].value==1)
        // 图片-上传主图
        this.markFun(15,5,0,creditArr[15].value=="true"? "上传正确":'上传错误',creditArr[15].value=="true")
        // 图片-上传副图1
        this.markFun(16,5,1,creditArr[16].value=="true"? "上传正确":'上传错误',creditArr[16].value=="true")
        // 图片-上传副图2
        this.markFun(17,5,2,creditArr[17].value=="true"? "上传正确":'上传错误',creditArr[17].value=="true")
        // 图片-上传副图3
        this.markFun(18,5,3,creditArr[18].value=="true"? "上传正确":'上传错误',creditArr[18].value=="true")
        // 图片-上传副图4
        this.markFun(19,5,4,creditArr[19].value=="true"? "上传正确":'上传错误',creditArr[19].value=="true")
        // 图片-上传副图5
        this.markFun(20,5,5,creditArr[20].value=="true"? "上传正确":'上传错误',creditArr[20].value=="true")
        // 图片-上传副图6
        this.markFun(21,5,6,creditArr[21].value=="true"? "上传正确":'上传错误',creditArr[21].value=="true")
        // 图片-上传副图7
        this.markFun(22,5,7,creditArr[22].value=="true"? "上传正确":'上传错误',creditArr[22].value=="true")
        // 图片-上传副图8
        this.markFun(23,5,8,creditArr[23].value=="true"? "上传正确":'上传错误',creditArr[23].value=="true")
        // 描述-卖点1
        this.markFun(24,6,0,creditArr[24].value||"没有填写",this.compare_nospaces(creditArr[24].value, JSON.parse(sessionStorage.caseInfo).描述信息1))
        // 描述-卖点2
        this.markFun(25,6,1,creditArr[25].value||"没有填写",this.compare_nospaces(creditArr[25].value, JSON.parse(sessionStorage.caseInfo).描述信息2))
        // 描述-卖点3
        this.markFun(26,6,2,creditArr[26].value||"没有填写",this.compare_nospaces(creditArr[26].value, JSON.parse(sessionStorage.caseInfo).描述信息3))
        // 描述-卖点4
        this.markFun(27,6,3,creditArr[27].value||"没有填写",this.compare_nospaces(creditArr[27].value, JSON.parse(sessionStorage.caseInfo).描述信息4))
        // 描述-卖点5
        this.markFun(28,6,4,creditArr[28].value||"没有填写",this.compare_nospaces(creditArr[28].value, JSON.parse(sessionStorage.caseInfo).描述信息5))
        // 描述-商品描述
        this.markFun(29,6,5,creditArr[29].value||"没有填写",this.compare_nospaces(creditArr[29].value, JSON.parse(sessionStorage.caseInfo).商品描述))
        // 关键字-搜索关键词
        this.markFun(30,7,0,creditArr[30].value||"没有填写",this.compare_nospaces(creditArr[30].value, JSON.parse(sessionStorage.caseInfo).搜索关键词))
      },
      markFun(num,ma1,ma2,mcont,isCredits){
         let info=JSON.parse(sessionStorage.regMarketArr)
         this.numScore= this.numScore + info[num].credit;
          this.regPage[ma1].maxMark=this.regPage[ma1].maxMark+info[num].credit
          this.regPage[ma1].markList[ma2].maxMark=this.regPage[ma1].markList[ma2].maxMark+info[num].credit
          let reg_us={
                name:info[num].regInfo,
                mcont:mcont,
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:info[num].knowledgePoint
            }
          if(isCredits){
              this.thisScore= this.thisScore+info[num].credit
              this.regPage[ma1].mark=this.regPage[ma1].mark+info[num].credit
              this.regPage[ma1].markList[ma2].mark=this.regPage[ma1].markList[ma2].mark+info[num].credit
              reg_us.credit=info[num].credit
              reg_us.result=1
              reg_us.resultCont=info[num].correctShow
              this.infoScore.push(reg_us)
          }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=info[num].errorShow
              this.infoScore.push(reg_us)
          }
      },
      cancalChild(e) {
       if(e=='score'){
         if(this.infoScore){
           this.isScore=true;
           this.getScoreList()
           this.isSelectPop=false;
         }
       }
        if(e=="video"){
          window.open("http://23270847.d.cturls.net/down/23270847/case/01368139935269392384.mp4",'foo', 'noopener=yes,noreferrer=yes')
       }
       if(e=="isLeasing"){
         this.isLeasing=false;
       }
       if(e=='AccountInfo'){
        this.AccountInfo=!this.AccountInfo;
       }
       else if(e=='leftBtn'){
         if(this.stepNum>0){
           this.stepNum--
           this.goRegPage(this.stepNum)
         }
       }
        else if(e=='rightBtn'){
         if(this.stepNum<8){
           this.stepNum++
           this.goRegPage(this.stepNum)
         }
      
       }
       else if(e=='leasing'){
         this.isLeasing=!this.isLeasing
       }
       else if(e=='chis'){
         if(this.chis=='0') {
              this.iframeWin.postMessage({
                chis:'1'
                }, '*') 
                this.chis='1'
                this.isChisShow=true;
         }else{
              this.iframeWin.postMessage({
              chis:'0'
              }, '*') 
              this.chis='0'
              this.isChisShow=false;
         } 
       }else if(e=='help'){
          if(this.help=='0') {
              this.iframeWin.postMessage({
                help:'1'
                }, '*') 
                this.help='1'
                this.isHelpShow=true;
         }else{
              this.iframeWin.postMessage({
              help:'0'
              }, '*') 
              this.help='0'
              this.isHelpShow=false;
         } 
       }
    },
  },
  components: {
    CaseHead,
    CommonPop
  }
};
</script>
<style lang="scss" scoped>

.colsPop{
  position: fixed;
  width:400px;
  height:625px;
  top:85px;
  background:#ffffff;
  box-shadow:0px 0px 20px rgba(0,0,0,0.16);
  border-radius:2px;
  box-sizing: border-box;
  padding: 0 24px 0 25px;
  left: 24px;
  z-index: 99999;
}

.colsCont{
  position: relative;
  .pinyin{
    position: absolute;
    left: 0px;
    bottom: -25px;
    border:1px solid #F3CD70;
    font-size: 12px;
    height: 30px;
    border-radius: 21px;
    line-height: 30px;
    text-align: center;
    width: 90px;
    cursor: pointer;
  }
  .lv{
    background-color: #F3CD70;
  }
}
.colsCont .close{
  position: absolute;
  top: 10px;
  right: -17px;
  cursor: pointer;
  color: #232F3E;
}
.colsCont .close img{
  width: 13px;
  height: 13px;
}
.colsCont{
  .tab{
    display: flex;
    justify-content: space-between;
    padding: 32px 0;
    .tabs{
      height: 34px;
      line-height: 34px;
      font-size: 14px;
      cursor: pointer;
    }
    .tabs:hover{
      color: #178AFF;
      border-bottom: 1px solid #178AFF;
    }
    .avt{
      color: #178AFF;
      border-bottom: 1px solid #178AFF;
    }
  }
  .boxConts{
    height: 500px;
    overflow: auto;
    position: relative;
    .btn{
      position: absolute;
      bottom: 0;
      right: 0px;
      height: 30px;
      line-height: 29px;
      display: flex;
      font-size: 14px;
      align-items: center;
      padding: 4px 10px;
      border-radius: 5px;
      // background-color: #;
      border: 1px solid #E8E8E8;
      background-color: white;
      cursor: pointer;
      img{
        width: 25px;
        height: 25px;
        margin-right: 5px;
      }
    }
    .btn:hover{
      background-color: #F3CD70;
      border: 1px solid #F3CD70;
    }
    ul{
      li{
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 20px;
        color: #000000;
        margin-bottom: 15px;
        .name{
          font-weight: bold;
        }
        .dev{
          color: #666666;
        }
        span{
          color: #FF0000;
        }
      }
      .list{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        img{
          width: 100px;
          height: 100px;
          margin-bottom: 15px;
        }
      }
    }
  }
}

.pyPop{
   height: 188px;
   left: auto;
   right: 0px;
   .close{
     top: 11px;
   }
   .head{
     height: 40px !important;
     line-height: 40px;
     .uname{
        padding-top: 0;
        font-size: 14px;
        line-height: 40px !important;
     }
   }
   .input_wrap{
     padding-top: 21px;
     .ipt{
       padding-bottom: 10px;
       display: flex;
       label{
         font-size:14px;
         margin-left: 5px;
         width: 42px;
        height:30px;
        line-height: 30px;
       }
       input{
         width:283px;
          height:30px;
          background:rgba(255,255,255,1);
          border:1px solid rgba(232,232,232,1);
          opacity:1;
          border-radius:4px;
          outline: none;
          box-sizing: border-box;
          padding-left: 10px;
       }
     }
   }
   .iBtn{
      width:68px;
      height:20px;
      background:rgba(243,205,112,1);
      opacity:1;
      border-radius:4px;
      text-align: center;
      position: absolute;
      font-size: 12px;
      line-height: 20px;
      right: 0px;
      bottom: -37px;
      cursor: pointer;
   }
}
.view{
  height:calc(100vh - 80px) ;
  margin: 0 auto;
}
.view  iframe{
  height:100%;
  width: 100%;
}
.Home{
  background-color: #FFFFFF;
}
.content{
  // max-width: 1380px;
  // padding-top:10px ;
  margin: 0 auto;
  box-sizing: border-box;
}
.siteWrap {
  display: flex;
}
.siteWrap .siteUl{
  display: flex;
  flex-wrap:wrap ;
}
.siteWrap .siteUl .siteLi{
  margin-right: 20px;
  margin-bottom: 20px;
}
.siteWrap .siteUl .siteLi:nth-child(5n-0){
  margin-right: 0px;
}
.siteWrap .siteUl .siteLi .icon{
  background-color: #232F3E;
  height: 128px;
}
.siteWrap .siteUl .siteLi .icon img{
  width: 96px;
  height: 96px;
  padding: 26px 82px 0 82px;
}
.siteWrap .siteUl .siteLi .name{
  color: #FFFFFF;
  background-color: #2F3A48;
  text-align: center;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}
// 评分弹窗
.pop_bg{
	width: 100%;
    left: 0px;
    top: 0px;
    height: 100%;
    position: fixed;
/*    user-select: none; */
    z-index: 99;
	background-color: #000;
    opacity: .5;
}
.scorePop{
  	position: fixed;
    left: 50%;
    top: 50%;
    z-index: 999;
    background-color: #fff;
    transform: translate(-50%, -50%);
    width: 1180px;
    height:500px;
    box-sizing: border-box;
    padding:0 23px 0 23px;
    .head{
      display: flex;
      position: relative;
      .el{
        display: flex;
        padding-top: 19px;
        .li{
          width: 77px;
          height: 77px;
          border:1px solid #D6D6D6;
          background-color: #fff;
          border-radius:50%;
          box-sizing: border-box;
          .num{
            width:40px;
            height:30px;
            font-size:22px;
            font-family:PingFang SC;
            font-weight:bold;
            line-height:30px;
            color: #000000;
            text-align: center;
            margin: 12px auto 0;
            border-bottom: 1px solid #D6D6D6;
          }
          .nx{
            font-size:12px;
            line-height:17px;
            color: #232F3E;
            text-align: center;
            line-height: 17px;
            margin-top: 6px;
          }
        }
        .avt{
          margin-right: 17px;
          background-color: #F3CD70;
          border:1px solid #F3CD70;
          .num{
            border-bottom: 1px solid #000000;
          }
        }
      }
      .ps{
        width:444px;
        height:17px;
        font-size:12px;
        font-weight:400;
        line-height:17px;
        color:#FF0000;
        margin-left: 17px;
        margin-top: 68px;
      }
      .btnScore{
          position: absolute;
          right: 24px;
          top:46px;
          width:110px;
          height:32px;
          background:#F3CD70;
          line-height: 32px;
          border-radius:4px;
          color: #232F3E;
          font-size:14px;
          text-align: center;
          cursor: pointer;
      }
      .close{
        position: absolute;
        top: 10px;
        right:5px;
        cursor: pointer;
        img{
          width: 16px;
          height: 16px;
        }
      }
    }
    .cont{
      margin-top: 10px;
      max-height: 358px;
      overflow-y: scroll;
      .titUl{
        display: flex;
        .li{
            flex: 1;
            border:1px solid #E1E1E2;
            padding-left: 12px;
            height: 50px;
            line-height: 23px;
            align-items: center;
            color: #000000;
            display: flex;
            font-size:14px;
            background-color: #EBEBEB;
            border-right:0;
           
        }
        .li:last-of-type{
          border-right:1px solid #E1E1E2;
        }
        .fx4{
            flex: 4; 
        }
      }
      .conList{
        .titUl{
          .li{
            font-size: 12px;
            background-color: #F5F5F5;
            display: flex;
            align-items: center;
            overflow:hidden; 
            text-overflow:ellipsis;
            display:-webkit-box; 
            -webkit-box-orient:vertical;
            -webkit-line-clamp:2; 
            padding-top: 15px;
          }
          .dP{
           
            img{
              width:20px;
              margin-right: 10px;
              vertical-align: middle;
              margin-top: -3px;
            }
          }  
        }
        .titUl:nth-child(odd){
           .li{
              border-top: 0;
             border-bottom: 0;
             background-color: #fff;
           }

        }
        .titUl:last-of-type{
           border-bottom:1px solid #E1E1E2;
            .li{
              border-bottom: 0;
            }
        }
        .avt{
            .li{
              color: #FF0000;
           }
        } 
      }
      
    }
}
.selectPop{
  position: fixed;
	left: 50%;
  top: 50%;
  z-index: 9999;
  background-color: #fff;
  transform: translate(-50%, -50%);
  box-shadow:0px 0px 20px rgba(0,0,0,0.16);
  width:400px;
  height:200px;
  border-radius:2px;
  box-sizing: border-box;
  padding: 0 25px;
  .title{
    border-bottom:1px solid #e8e8e8;
    height: 81px;
    line-height: 81px;
    font-size:18px;
    color: #000;
    text-align: center;
    position: relative;
    .close{
      position: absolute;
      top: -13px;
      right: 0px;
      cursor: pointer;
      img{
        width: 16px;
        height: 16px;
      }
    }
  }
  .btn{
    width:120px;
    height:40px;
     text-align: center;
    background:rgba(243,205,112,1);
    opacity:1;
    border-radius:21px;
    font-size:14px;
    color:rgba(35,47,62,1);
    line-height: 40px;
    margin: 47px auto 0;
    cursor: pointer;
  }
}
.tipsPop{
	width: 400px;
	height: 235px;
	box-shadow:0px 0px 20px rgba(0,0,0,0.16);
	border-radius:2px;
	position: fixed;
	left: 50%;
  top: 50%;
  z-index: 9999;
  background-color: #fff;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  padding: 0  32px 0 34px;
  .head{
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-bottom:1px solid #E8E8E8;
    color: #000000;
    position: relative;
     .icon{
        position: absolute;
        right: -10px;
        top: 0px;
        cursor: pointer;
        img{
          width: 10px;
          height: 10px;
        }
      } 
  }
  .co{
    width:322px;
    line-height:20px;
    font-size:12px;
    margin-top: 12px;
    text-align: center;
  }
  .cont{
    text-align: center;
    line-height:20px;
    font-size:12px;
    margin: 0 auto;
    width:300px;
    padding-top: 25px;
  }
  .btnWrap{
    text-align: center;
    margin-top:34px;
    .btn{
      width:110px;
      height:32px;
      border-radius: 4px;
      background-color: #F3CD70;
      color: #232F3E;
      font-size:12px;
      display: inline-block;
      line-height: 32px;
      cursor: pointer;
      box-sizing: border-box;
      vertical-align: middle;
    }
    .btnN{
       width:110px;
      height:32px;
      border-radius: 4px;
      background-color: #FFFFFF;
      border:1px solid rgba(243,205,112,1);
      box-sizing: border-box;
      color: #57616C;
      font-size:12px;
      display: inline-block;
      line-height: 32px;
      cursor: pointer;
      margin-left: 10px;
      vertical-align: middle;
    }
  }
}
</style>
<style >
  .Home .el-carousel__container  {
    height: 580px;
  }
</style>